import  {   HttpHeaders 
        ,   HttpParams          } from "@angular/common/http";
import  {   Injectable          } from "@angular/core";
import  { ExtraParamsAPI } from "src/app/enums/network/request/extraparams/extraparams.api";
import  { ExtraParamsField } from "src/app/enums/network/request/extraparams/extraparams.fields";
import  {   NetworkManager      } from "src/app/managers/network/network.manager";

@Injectable
({
  providedIn: 'root'
})
export class ExtraParamsRequest
{
    constructor(
        private _network: NetworkManager
    ){}

    public async getParamByUUID ( 
      uuid: string 
    ){
      const  url = this._network.ExtraParamsApi() + ExtraParamsAPI.GET_PARAM_BY_UUID

      const form = new URLSearchParams();
      form.append( ExtraParamsField.UUID, uuid );
      
      return this._network.http().put( url, form.toString(), {} ).toPromise()
    } 

    public async getParamByCode( 
      token   :   string
    , level   :   string
    , levelid :   number
    , type    :   string
    , code    :   string
    ){
      const  url = this._network.ExtraParamsApi() + ExtraParamsAPI.GET_PARAM_BY_CODE

      const headers = new HttpHeaders() .append( ExtraParamsField.TOKEN, token )

      const form = new URLSearchParams();
      form.append( ExtraParamsField.LEVEL            , level                  );
      form.append( ExtraParamsField.LEVELID          , levelid.toString()     );
      form.append( ExtraParamsField.TYPE             , type                   );
      form.append( ExtraParamsField.CODE             , code                   );

      return this._network.http().put( url , form.toString() , { headers }).toPromise()
    }

    public async getParamsByCodes( 
      token   :   string
    , level   :   string
    , levelid :   number
    , type    :   string
    , codes   :   string
    ){
      const  url = this._network.ExtraParamsApi() + ExtraParamsAPI.GET_PARAMS_BY_CODES

      const headers = new HttpHeaders() .append( ExtraParamsField.TOKEN, token )

      const form = new URLSearchParams();
      form.append( ExtraParamsField.LEVEL            , level                  );
      form.append( ExtraParamsField.LEVELID          , levelid.toString()     );
      form.append( ExtraParamsField.TYPE             , type                   );
      form.append( ExtraParamsField.CODES            , codes                  );

      return this._network.http().put( url , form.toString() , { headers }).toPromise()
    }
}